import { useTranslation } from "react-i18next";
import { getAssetUrl } from "@/utils/helpers";

export const BankTransferImportantNotes = () => {
  const { t } = useTranslation();
  return (
    <div className="ps-p-y-4 ps-font-body ps-text-v2-text-base-primary ps-text-body-v2-md">
      <div className="ps-flex ps-flex-col ps-gap-8">
        <div className="ps-flex ps-gap-4 ps-items-center">
          <img
            src={getAssetUrl("account.svg", "icons")}
            alt="account-illustration"
          />
          <div>
            {t("deposit.bank_transfer_important_notes.account_name_match")}
          </div>
        </div>
        <div className="ps-flex ps-gap-4 ps-items-center">
          <img
            src={getAssetUrl("document.svg", "icons")}
            alt="document-illustration"
          />
          <div>
            {t("deposit.bank_transfer_important_notes.include_reference_code")}
          </div>
        </div>
        <div className="ps-flex ps-gap-4 ps-items-center">
          <img
            src={getAssetUrl("details.svg", "icons")}
            alt="details-illustration"
          />
          <div>
            {t("deposit.bank_transfer_important_notes.enter_all_details")}
          </div>
        </div>
      </div>
    </div>
  );
};
